import * as React from 'react';
import { connect } from 'react-redux';
import { getOrgUsers, getUserById, setUserCurrentPage, updateUser } from '~/apps/shared/actions/users';
import {getLocationById, getOrgLocations} from '~/apps/shared/actions/locations';
import UserUpdateFormOverlay from '../../components/users/UserUpdateFormOverlay';
import Loader from '~/common/components/Loader';
import { Features, UserRole } from '~/apps/shared/consts';
import {SearchableModelHelper} from "~/lib/forms/select";
import {createLocationHelper, createOrgLocationsHelper, createStatusHelper} from "~/apps/shared/services/forms";
import {getSaleStatus, getSaleStatuses} from "~/apps/pos/shared/services/helpers";


class UserEditPopup extends React.Component<any, any> {
  locationHelper: SearchableModelHelper;

  refresh = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    const { dispatch, orgId, currentUser: { role, locationId }, currentUser } = this.props;

    dispatch(getUserById(this.props.userId));

    if (role == UserRole.WAREHOUSE_MANAGER) {
      dispatch(getLocationById(locationId));
    } else {
      this.locationHelper = createOrgLocationsHelper(this.refresh, orgId,  {
        label: '- Without Location -',
        value: null,
      });
    }
  }

  onSubmit = (data) => {
    const { dispatch, userId, onReturn } = this.props;
    const req = {
      ...data,
      locationId: !data.locationId ? '' : data.locationId,
      departmentId: !data.departmentId ? null : data.departmentId,
    };

    return dispatch(updateUser(userId, req))
      .then(() => {
        dispatch(getOrgUsers()).then(() => {
          dispatch(setUserCurrentPage(0));
          onReturn();
        });
      });
  };

  onClose = () => {
    this.props.onReturn();
  };

  getWarehouseManagerLocationsOptions = () => {
    const { locations: { entities }, currentUser: { role, locationId } } = this.props;

    // if user is not a WAREHOUSE MANAGER we are working with locationHelper
    if (role != UserRole.WAREHOUSE_MANAGER) {
      return null;
    }

    if (!entities?.[locationId]) return [];

    return [{
      label: entities[locationId].name,
      value: locationId,
    }];
  };


  render() {
    const { users, userId, information, departments } = this.props;
    const user = users.entities[userId];
    const { loading, errorMessage } = users.ui;
    const userName = !user ? '' : user.username;

    const hasDepartmentFeature = information.entities.features.includes(Features.DEPARTMENTS);
    const hasFHIFeature = information.entities.features.includes(Features.FHI);
    const departmentOptions = departments.ui.currentList.map(id => {
      const dep = departments.entities[id];

      return {
        label: dep.name,
        value: dep.id,
        locationId: dep.locationId,
      }
    });

    if (loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    return (
      <UserUpdateFormOverlay
        headTitle={`Edit User - ${userName}`}
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        user={user}
        locations={this.getWarehouseManagerLocationsOptions()}
        locationHelper={this.locationHelper}
        errorMessage={errorMessage}
        hasDepartmentFeature={hasDepartmentFeature}
        departmentOptions={departmentOptions}
        hasFHIFeature={hasFHIFeature}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.shared.users,
    currentUser: state.shared.auth.currentUser,
    locations: state.shared.locations,
    information: state.shared.information,
    departments: state.shared.departments,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEditPopup) as any;
